import Vue from 'vue';
import Vuex from 'vuex';

import serverData from "./modules/serverData";
import configurations from "./modules/configurations";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        translationHelper:{},
        roomFilters: { "sources": [], "accounts": [], "themes": [], "groups": [] }
    },
    getters: {
        translationHelper: state => {
            return state.translationHelper;
        },
        roomFilters: state => {
            return state.roomFilters;
        }
    },
    mutations: {
        updateTranslationHelper: (state, translationHelper) => {
            state.translationHelper = translationHelper;
        },
        updateRoomFilters: (state, roomFilters) => {
            state.roomFilters = roomFilters;
        }
    },
    actions: {
        updateTranslationHelper: ({ commit }, translationHelper) => {
           commit('updateTranslationHelper', translationHelper);
        },
        updateRoomFilters: ({ commit }, roomFilters) => {
            commit('updateRoomFilters', roomFilters);
        }
    },
    modules: {
        serverData,
        configurations
    }
});